/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ComingSoonStyles.scss'; // The inline CSS from the HTML

const ComingSoon = () => {
  useEffect(() => {
    const cssLinks = [
      '/launch-assets/css/bodhiwell_tokens.css',
      '/launch-assets/css/coherence.css',
      '/launch-assets/css/landing-page.css',
      '/launch-assets/css/base-oficial.css'
    ];
    
    // Add link tags
    const links = cssLinks.map(href => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.launchStyle = 'true';
      document.head.appendChild(link);
      return link;
    });

    // Also inject font
    const fontLink1 = document.createElement('link');
    fontLink1.rel = 'preconnect';
    fontLink1.href = 'https://fonts.googleapis.com';
    fontLink1.dataset.launchStyle = 'true';
    document.head.appendChild(fontLink1);

    const fontLink2 = document.createElement('link');
    fontLink2.rel = 'preconnect';
    fontLink2.href = 'https://fonts.gstatic.com';
    fontLink2.crossOrigin = 'anonymous';
    fontLink2.dataset.launchStyle = 'true';
    document.head.appendChild(fontLink2);

    const fontLink3 = document.createElement('link');
    fontLink3.rel = 'stylesheet';
    fontLink3.href = 'https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&display=swap';
    fontLink3.dataset.launchStyle = 'true';
    document.head.appendChild(fontLink3);

    document.body.classList.add('launch-locked');

    return () => {
      // Cleanup styles on unmount
      const elements = document.querySelectorAll('[data-launch-style="true"]');
      elements.forEach(el => el.remove());
      document.body.classList.remove('launch-locked');
    };
  }, []);

  return (
    <div id="coming-soon-wrapper">
      <header className="header" aria-hidden="true" inert={true}>
        <div className="header-inner">
          <span className="logo"><img src="/launch-assets/img/logo-bodhiwell-color.png" alt="" /></span>
          <nav className="nav" aria-label="Navegación bloqueada">
            <a href="#" tabIndex={-1}>Acerca de</a>
            <a href="#" tabIndex={-1}>¿Cómo funciona?</a>
            <a href="#" tabIndex={-1}>Comunidad⌄</a>
            <a href="#" tabIndex={-1}>Blog</a>
            <a href="#" tabIndex={-1}>Contacto</a>
          </nav>
          <div className="actions">
            <span className="lang-switch" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/><path d="M2 12H22M12 2C15 6 15 18 12 22C9 18 9 6 12 2Z" stroke="currentColor" strokeWidth="1.5"/></svg>
              <span>ES</span>
            </span>
            <span className="login-link">Acceder</span>
            <span className="btn btn-outline header-btn btn-green">Crear mi cuenta</span>
          </div>
        </div>
      </header>

      <main aria-hidden="true" inert={true}>
        <section className="hero">
          <video className="hero-video" autoPlay muted loop playsInline aria-hidden="true">
            <source src="/launch-assets/video/home-hero.mp4" type="video/mp4" />
          </video>
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1 className="landing-h1 landing-h1--hero">Amplía tu mirada<br />sobre la salud</h1>
            <p className="hero-sub landing-body landing-body--hero">Accedé a profesionales, contenido de valor y una mirada<br />más amplia para acompañar tu camino de salud.</p>
            <div className="hero-cta-group">
              <span className="btn btn-primary hero-cta">Crear mi cuenta</span>
              <p className="hero-note landing-small landing-small--hero">Creá tu cuenta sin costo y empezá<br />a explorar profesionales y recursos.</p>
            </div>
          </div>
        </section>
      </main>

      <section className="launch-veil" role="dialog" aria-modal="true" aria-labelledby="launchTitle" aria-describedby="launchDescription">
        <div className="launch-message">
          <div className="launch-message__brand" aria-label="Bodhiwell">
            <img className="launch-message__flower" src="/launch-assets/img/flor.png" alt="" aria-hidden="true" />
            <img className="launch-message__logo" src="/launch-assets/img/logo-bodhiwell-color.png" alt="Bodhiwell" />
          </div>
          <div className="launch-message__content">
            <h2 id="launchTitle">Muy pronto.</h2>
            <div className="launch-message__copy" id="launchDescription">
              <p>Un punto de encuentro entre la medicina convencional, tradicional y complementaria.</p>
              <p>Una comunidad donde cada profesional y cada consultante aportan, crecen y transforman su bienestar.</p>
            </div>
          </div>
          <div style={{ 
            marginTop: 'auto', 
            paddingTop: '20px', 
            position: 'relative', 
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            gap: '12px'
          }}>
            <span className="launch-message__status" style={{ marginTop: 0 }}>Estamos trabajando en la experiencia</span>
            <Link to="/login" className="btn btn-primary" style={{ 
              padding: '12px 32px', 
              borderRadius: '30px', 
              whiteSpace: 'nowrap',
              backgroundColor: '#82B194',
              color: '#ffffff',
              border: '1px solid #82B194'
            }}>
              Ya estoy registrado
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComingSoon;